<template>
  <!-- Tablero de control -->
  <v-form ref="form" autocomplete="off">
    <v-row>
      <!--Tipo de documento-->
      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          v-model="editedItem.TypeDocument_ID"
          :items="ArrayTypeDocument_ID"
          :item-title="
            (ArrayTypeDocument_ID) =>
              ArrayTypeDocument_ID.ValorNumero +
              '-' +
              ArrayTypeDocument_ID.Descripcion
          "
          item-value="ValorNumero"
          color="primary"
          label="Tipo de documento:"
          dense          
          :rules="[(v) => !!v || 'Campo obligatorio']"
          :clearable="clearcampos.TypeDocument_ID"
          :readonly="readcampos.TypeDocument_ID"
        >
        </v-autocomplete>
      </v-col>
      <!--Documento-->
      <v-col cols="12" sm="6" md="4">
        <v-text-field
          v-model="editedItem.Document_ID"
          label="Documento"
          hint="Digite Información"
          dense
          @change="ChangeDocumento_ID()"
          :rules="[(v) => !!v || 'Campo obligatorio']"          
          maxlength="20"
          counter="20"
          :clearable="clearcampos.Document_ID"
          :readonly="readcampos.Document_ID"
        >
        </v-text-field>
      </v-col>
      <!--Nombre-->
      <v-col cols="12" sm="6" md="4">
        <span>Nombre: {{ NombrePersona }}</span>
      </v-col>
      <!--Tipo de relación-->
      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          v-model="editedItem.TypeRelation"
          :items="ArrayTypeRelation"
          :item-title="
            (ArrayTypeRelation) =>
              ArrayTypeRelation.Valor + '-' + ArrayTypeRelation.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Tipo de relación:"
          dense          
          :rules="[(v) => !!v || 'Campo obligatorio']"
          :clearable="clearcampos.TypeRelation"
          :readonly="readcampos.TypeRelation"
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <!--////////////////////////////////////////////// Auditoria ////////////////////////////////////////////////////////////-->
    <br />
    <v-row>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Creación: {{ editedItem.UsuarioCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span
          >Usuario Actualización: {{ editedItem.UsuarioActualizacion }}</span
        >
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Creación: {{ editedItem.FechaCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Actualización: {{ editedItem.FechaActualizacion }}</span>
      </v-col>
    </v-row>
    <div align="right">
      <br />
      <v-btn
        size="x-large"
        v-if="!buttonSave && editedIndex == -1"
        color="green"
        text
        @click="ValidateCampos"
      >
        Guardar
      </v-btn>
    </div>
  </v-form>
  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "rca_registro",
  props: {
    editedIndex: {
      type: Number,
      default: 0,
      Description: "Cambia de actualización a creación o visceversa",
    },
    infoedit: {
      type: Object,
      default: [],
      Description: "Información de datos",
    },
    ContratoID: {
      type: String,
      default: "",
      Description: "Información de documento",
    },
    page: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    Exito: {
      type: String,
      default: "",
      Description: "Información de respuesta post o put",
    },
  },
  data() {
    return {
      progreso: false,
      componenteview: 0,
      buttonSave: false,
      editedItem: {
        Contrato_ID: null,
        Ref_1: null,
        TypeDocument_ID: null,
        Document_ID: null,
        TypeRelation: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      defaultItem: {
        Contrato_ID: null,
        Ref_1: null,
        TypeDocument_ID: null,
        Document_ID: null,
        TypeRelation: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      ArrayTypeDocument_ID: [],
      ArrayTypeRelation: [],
      NombrePersona: null,
      clearcampos: {
        Contrato_ID: true,
        Ref_1: true,
        TypeDocument_ID: true,
        Document_ID: true,
        TypeRelation: true,
      },
      readcampos: {
        Contrato_ID: false,
        Ref_1: false,
        TypeDocument_ID: false,
        Document_ID: false,
        TypeRelation: false,
      },
    };
  },
  methods: {
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      if (
        this.editedItem.Contrato_ID == "" ||
        this.editedItem.Contrato_ID == null ||
        this.editedItem.TypeDocument_ID == "" ||
        this.editedItem.TypeDocument_ID == null ||
        this.editedItem.Document_ID == "" ||
        (this.editedItem.Document_ID == null) |
          (this.editedItem.TypeRelation == "") ||
        this.editedItem.TypeRelation == null
      ) {
        validate = true;
      } else if (
        this.editedItem.TypeDocument_ID != "" &&
        this.editedItem.TypeDocument_ID != null &&
        this.editedItem.Document_ID != "" &&
        this.editedItem.Document_ID != null &&
        (this.NombrePersona == "" || this.NombrePersona == null)
      ) {
        validate = true;
      }
      // Consultas a Ejecutar
      if (!validate) {
        var userperfil = this.$store.getters.userperfil;
        this.editedItem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
        this.editedItem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;
        this.postRegistro();
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
        this.$refs.form.validate();
      }
    },
    // Crear Registro
    async postRegistro() {
      this.progreso = true;
      this.axios
        .post("/ActivosO/Relacion_Actores/CR0/", this.editedItem)
        .then((result) => {
          this.reset();
          var data = false;
          this.$emit("update:page", data);
          this.$emit("update:Exito", result.data);
          this.$swal({
            icon: "success",
            title: "¡Éxito!",
            html: " El registro fue guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    // Get para obtener nombre de la persona
    async getNombrePersona() {
      this.NombrePersona = null;
      if (
        this.editedItem.TypeDocument_ID != "" &&
        this.editedItem.TypeDocument_ID != null &&
        this.editedItem.Document_ID != "" &&
        this.editedItem.Document_ID != null
      ) {
        this.axios
          .get(
            "/Personas/Cliente/CD1/" +
              this.editedItem.TypeDocument_ID +
              "/" +
              this.editedItem.Document_ID
          )
          .then((response) => {
            if (!response.data[0].Error) {
              this.NombrePersona = response.data[0].DescNombre;
            } else {
              this.NombrePersona = null;
              this.$swal({
                icon: "warning",
                title: "Error al consultar datos",
                html: response.data[0].Mensaje,
              });
            }
          })
          .catch((error) => {
            const registro = error.response.data;
            const mensajeerror =
              registro.Mensaje || registro.ExceptionMessage || registro;
            switch (error.response.status) {
              case 404:
                this.$swal({
                  icon: "warning",
                  title: "Consulta inexistente.",
                  html: mensajeerror,
                });
                break;
              default:
                this.$swal({
                  icon: "error",
                  title: "Error al consultar",
                  html:
                    " El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                    mensajeerror +
                    "</code></small>",
                });
                break;
            }
          });
      }
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    // Change Documento
    ChangeDocumento_ID() {
        if (
          this.editedItem.Document_ID == "" ||
          this.editedItem.Document_ID == null
        ) {
          this.NombrePersona = null;
        } else {
          this.getNombrePersona();
        }
    },    
    // Resetear campos
    reset() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.clearcampos.TypeDocument_ID = true;
      this.readcampos.TypeDocument_ID = false;
      this.clearcampos.Document_ID = true;
      this.readcampos.Document_ID = false;
      this.clearcampos.TypeRelation = true;
      this.readcampos.TypeRelation = false;
    },
    // Cargue Combos
    CargueCombos() {
      var TipoDocumento = this.$store.getters.MTablaSeleccion[2].TablaSeleccion;
      this.ArrayTypeDocument_ID = TipoDocumento.filter(
        (item) => item.Valor != null
      );
      this.ArrayTypeRelation =
        this.$store.getters.MTablaSeleccion[54].TablaSeleccion;
    },
    // Actualizar carga
    ActualizarCargue() {
      if (this.editedIndex != -1) {
        // Actualizar
        this.editedItem = this.infoedit;
        this.clearcampos.TypeDocument_ID = false;
        this.readcampos.TypeDocument_ID = true;
        this.clearcampos.Document_ID = false;
        this.readcampos.Document_ID = true;
        this.clearcampos.TypeRelation = false;
        this.readcampos.TypeRelation = true;
        this.ChangeDocumento_ID();
      } else {
        this.editedItem.Contrato_ID =
          this.ContratoID != null ? this.ContratoID : null;
      }
    },
  },
  mounted() {
    this.CargueCombos();
    this.ActualizarCargue();
  },
};
</script>
